import { MainApi } from "./MainApi";

export class CountryApi {
  static baseUrl = `${MainApi.urlPrefix}/country`;

  static getCountries = () => () => MainApi.api.get(CountryApi.baseUrl);
}
